import { Component, OnInit } from '@angular/core';
import { QuotationHistoryService, Quotation } from "app/services/quotation-history.service";
import { UserService, User } from "app/services/user.service";
import { CompanyService, Company } from "app/services/company.service";
import { Router, ActivatedRoute, Params } from '@angular/router';
import { PaginationService } from "app/services/pagination.service";
import * as _ from 'underscore';

@Component({
    selector: 'app-quotation-history',
    templateUrl: './quotation-history.component.html',
    styleUrls: ['./quotation-history.component.css']
})
export class QuotationHistoryComponent implements OnInit {
    users: any;
    param_id: string;
    data: any;
    compnay_id: any;
    quotation: any;
    companies: Quotation[];
    cat_assoc = {};
    user: any;
    user_companies;
    quotation_companies;
	pager: any = {};
	pagedItems: any[];
    q: string = '';
    e: string = '';
    private allItems: any;
    private allItemsOri: any;
    length:any;

    constructor(
        private quotationService: QuotationHistoryService,
        private userService: UserService,
        private companyService: CompanyService,
        private router: Router,
        private route: ActivatedRoute,
        private paginationService: PaginationService,
    ) { }

    ngOnInit() {
        this.param_id = this.route.snapshot.params['id'];
        if (!this.param_id) {
            this.quotationService.getQuotations().subscribe(quotations => {
                var users_id = {};
                quotations.forEach(q => {
                    if(q.status == 'sent' && typeof q.company != 'undefined') {
                        users_id[q.uid] = true;
                    }
                });

                this.userService.getUsers().subscribe(users => {
                    this.users = users.filter(user => !!users_id[user.$key]).sort((a, b) => {
                        if (a.fullname == b.fullname) {
                            return 0;
                        }
                        return a.fullname.toLowerCase() < b.fullname.toLowerCase() ? -1 : 1;
                    });

                    this.allItemsOri = _.clone(this.users);
                    this.allItems = _.clone(this.users);
                    this.setPage(1);
                });
            })
        }
        else 
        {
            this.quotationService.getQuotationBasedOnUser(this.param_id).subscribe(quotations => {
                var companies_key = {};
                var sent = quotations.filter(q => {
                    if(q.status == 'sent' && typeof q.company != 'undefined' && !companies_key[q.company_key]) {
                        companies_key[q.company_key] = true;
                        return true;
                    }
                    return false;
                });

                var companies = sent.map(q => {
                    q.company.key = q.company_key;
                    return q.company;
                }).sort((a, b) => {
                    if (a.name == b.name) {
                        return 0;
                    }
                    return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
                });

                this.length      = companies.length;
                this.allItemsOri = _.clone(companies);
                this.allItems    = _.clone(companies);
                this.setPage(1);
            });
        }
    }

    // salesClick(key){
    //   this.router.navigate(['/quotation-history/'+key]);
    // }

    companyClick(key, param_id) {

    }

    trackByIndex(index: number, obj: any): any {
        return index;
    }

    goBack() {
        window.history.back();
    }

    setPage(page: number) {
        // get pager object from service
        this.pager = this.paginationService.getPager(this.allItems.length, page);

        // get current page of items
        this.pagedItems = this.allItems.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }

    filter_result() {
        if(!this.param_id){
            if(this.q || this.e) {
                this.allItems = this.allItemsOri.filter(item => {
                    var regex = new RegExp( this.escapeRegExp(this.q), 'gi' );
                    var regex2 = new RegExp( this.escapeRegExp(this.e), 'gi' );
                    
                    var name = regex.test(item.fullname);
                    var e_number = regex2.test(item.employee_number);
                    console.log(name)
                    console.log(this.q)
                    return name && e_number;
                })
            }
            else
            {
                this.allItems = this.allItemsOri;
            }

            this.setPage(1);
        } else {
            if(this.q){
                this.allItems = this.allItemsOri.filter(item => {
                     var regex = new RegExp( this.escapeRegExp(this.q), 'gi' );

                     var name = regex.test(item.name);

                     console.log(item.name)
                     console.log(this.q)

                     return name;
                })
            }
            else {
                this.allItems = this.allItemsOri;
            }
            this.setPage(1);
        }

	}

	escapeRegExp(str) {
		return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	}

}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/quotation/quotation-history/quotation-history.component.ts